import { render, staticRenderFns } from "./PatientVoiceUpload.vue?vue&type=template&id=8489cec8&scoped=true"
import script from "./PatientVoiceUpload.vue?vue&type=script&lang=js"
export * from "./PatientVoiceUpload.vue?vue&type=script&lang=js"
import style0 from "./PatientVoiceUpload.vue?vue&type=style&index=0&id=8489cec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8489cec8",
  null
  
)

export default component.exports